import Application from '@ember/application';

import loadInitializers from 'ember-load-initializers';
import Resolver from 'ember-resolver';

import config from 'register-partners-js/config/environment';

import * as Sentry from './sentry';
import './utils/client-init';
import './deprecation-workflow';
import 'register-partners-js/assets/app.css';

Sentry.init();

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver;
}

loadInitializers(App, config.modulePrefix);
